import alarmHistory from "@/pages/giveAnAlarm/alarmHistory" //报警历史查询
import alarmPending from "@/pages/giveAnAlarm/alarmPending" //报警待处理
import alarmSetting from "@/pages/giveAnAlarm/alarmSetting" //报警设置
export default [{
  path: "alarmPending",
  name: "alarmPending",
  meta: {
    title: "待处理",
    requireAuth: true
  },
  component: alarmPending,
}, {
  path: "alarmHistory",
  name: "alarmHistory",
  meta: {
    title: "历史查询",
    requireAuth: true
  },
  component: alarmHistory,
},{
  path: "alarmSetting",
  name: "alarmSetting",
  meta: {
    title: "报警设置",
    requireAuth: true
  },
  component: alarmSetting,
}]



// WEBPACK FOOTER //
// ./src/router/giveAnAlarm.js